import React from "react";
import { Outlet } from "react-router-dom";

export const EmployeeManagementLayOut = () => {
  return (
    <div style={{ position : "fixed", width: "100%", height: "100%", overflow: "auto" }}>
      <Outlet />
    </div>
  );
};
